module.exports = __webpack_public_path__ + "static/media/xox.3e45129a.png";